<template>
  <portal to="ModalRecommendation">
    <div class="modal-backdrop overflow-auto py-lg-3">
      <div class="card">
        <div class="d-flex justify-content-end">
          <a>
            <img
              src="@/assets/icon/close.png"
              alt="close"
              @click="$emit('close', 'update')"
            >
          </a>
        </div>
        <div class="d-flex justify-content-center my-3">
          <h5 class="font-weight-bold">
            {{ $t('manage-question.head.update') }}
          </h5>
        </div>
        <div
          v-if="isLoadingGet"
          class="text-center"
        >
          <div class="spinner-border spinner-border-sm">
            <span class="sr-only">
              Loading...
            </span>
          </div>
        </div>
        <div
          v-else
          class="overflow-auto"
        >
          <div class="card-body mx-3">
            <div class="row mb-3">
              <div class="col-sm-6 mb-3 mb-sm-0">
                <small class="font-weight-bold">
                  {{ $t('manage-question.label.order') }}
                </small>
                <input
                  v-model="form.sequence"
                  type="text"
                  class="form-control form-control-sm"
                  :class="{ 'border border-danger': $v.form.sequence.$error }"
                  :placeholder="$t('manage-question.placeholder.order')"
                >
                <template v-if="!$v.form.sequence.required && $v.form.sequence.$error">
                  <small class="text-danger">
                    {{ $t('manage-question.error.required', { name: $t('manage-question.label.order') }) }}
                  </small>
                </template>
                <template v-if="!$v.form.sequence.numeric && $v.form.sequence.$error">
                  <small class="text-danger">
                    {{ $t('manage-question.error.numeric') }}
                  </small>
                </template>
              </div>
              <div class="col-sm-6">
                <small class="font-weight-bold">
                  {{ $t('manage-question.label.type') }}
                </small>
                <v-select
                  v-model="form.type"
                  label="name"
                  class="sm"
                  :options="questionType"
                  :reduce="getReduceId"
                  :class="{ 'border border-danger': $v.form.type.$error }"
                  :placeholder="$t('manage-question.placeholder.type')"
                />
                <template v-if="!$v.form.type.required && $v.form.type.$error">
                  <small class="text-danger">
                    {{ $t('manage-question.error.required', { name: $t('manage-question.label.type') }) }}
                  </small>
                </template>
              </div>
            </div>
            <div class="mb-3">
              <small class="font-weight-bold">
                {{ $t('manage-question.label.question-id') }}
              </small>
              <textarea
                v-model="form.titleIdn"
                class="form-control form-control-sm"
                rows="5"
                :class="{ 'border border-danger': $v.form.titleIdn.$error }"
                :placeholder="$t('manage-question.placeholder.question-id')"
              />
              <template v-if="!$v.form.titleIdn.required && $v.form.titleIdn.$error">
                <small class="text-danger">
                  {{ $t('manage-question.error.required', { name: $t('manage-question.label.question-id') }) }}
                </small>
              </template>
            </div>
            <div class="mb-3">
              <small class="font-weight-bold">
                {{ $t('manage-question.label.question-en') }}
              </small>
              <textarea
                v-model="form.titleEng"
                class="form-control form-control-sm"
                rows="5"
                :class="{ 'border border-danger': $v.form.titleEng.$error }"
                :placeholder="$t('manage-question.placeholder.question-en')"
              />
              <template v-if="!$v.form.titleEng.required && $v.form.titleEng.$error">
                <small class="text-danger">
                  {{ $t('manage-question.error.required', { name: $t('manage-question.label.question-en') }) }}
                </small>
              </template>
            </div>
            <template v-if="form.type === 'checkbox' || form.type === 'radio_button'">
              <div>
                <div class="border-bottom border-secondary">
                  <small class="font-weight-bold text-info">
                    {{ $t('manage-question.label.choices') }}
                  </small>
                </div>
                <draggable v-model="choicesArr">
                  <transition-group>
                    <div
                      v-for="(element, e) in choicesArr"
                      :key="element.id"
                      class="d-flex"
                    >
                      <div class="drag-card my-3 py-1 p-md-2 col-11">
                        <div class="row">
                          <div class="col-md-4">
                            <small class="font-weight-bold">
                              {{ $t('manage-question.label.value') }}
                            </small>
                            <v-select
                              v-model="element.value"
                              :options="valueType"
                              class="mb-1 bg-white"
                              :class="{ 'border border-danger': $v.choicesArr.$each.$iter[e].value.$error }"
                            />
                            <template v-if="!$v.choicesArr.$each.$iter[e].value.required && $v.choicesArr.$each.$iter[e].value.$error">
                              <small class="text-danger">
                                {{ $t('manage-question.error.required', { name: $t('manage-question.label.value') }) }}
                              </small>
                            </template>
                          </div>
                          <div class="col-md-8">
                            <small class="font-weight-bold">
                              {{ $t('manage-question.label.title-id') }}
                            </small>
                            <input
                              v-model="element.titleIdn"
                              type="text"
                              class="form-control form-control-sm mb-1 bg-white"
                              :class="{ 'border border-danger': $v.choicesArr.$each.$iter[e].titleIdn.$error }"
                              :placeholder="$t('manage-question.placeholder.title-id')"
                            >
                            <template v-if="!$v.choicesArr.$each.$iter[e].titleIdn.required && $v.choicesArr.$each.$iter[e].titleIdn.$error">
                              <small class="text-danger">
                                {{ $t('manage-question.error.required', { name: $t('manage-question.label.title-id') }) }}
                              </small>
                              <br>
                            </template>
                            <small class="font-weight-bold">
                              {{ $t('manage-question.label.title-en') }}
                            </small>
                            <input
                              v-model="element.titleEng"
                              type="text"
                              class="form-control form-control-sm mb-1 bg-white"
                              :class="{ 'border border-danger': $v.choicesArr.$each.$iter[e].titleEng.$error }"
                              :placeholder="$t('manage-question.placeholder.title-en')"
                            >
                            <template v-if="!$v.choicesArr.$each.$iter[e].titleEng.required && $v.choicesArr.$each.$iter[e].titleEng.$error">
                              <small class="text-danger">
                                {{ $t('manage-question.error.required', { name: $t('manage-question.label.title-en') }) }}
                              </small>
                            </template>
                          </div>
                        </div>
                      </div>
                      <div class="col-1 my-auto">
                        <a>
                          <img
                            src="@/assets/icon/delete.png"
                            alt="delete"
                            @click="deleteChoices(element.id)"
                          >
                        </a>
                      </div>
                    </div>
                  </transition-group>
                </draggable>
                <button
                  class="d-flex justify-content-center col-6 col-sm-2 btn btn-info mt-4"
                  @click="addChoices"
                >
                  <div class="mr-3">
                    <img
                      src="@/assets/icon/add-white.png"
                      alt="add"
                    >
                  </div>
                  <div class="pt-1">
                    {{ $t('manage-question.add') }}
                  </div>
                </button>
              </div>
            </template>
          </div>
        </div>
        <div class="d-flex justify-content-center my-3">
          <button
            v-if="!isLoadingSubmit"
            class="col-6 col-sm-2 btn btn-info"
            @click="submit"
          >
            {{ $t('manage-question.save') }}
          </button>
          <button
            v-else
            class="col-6 col-sm-2 btn btn-info"
          >
            <div class="spinner-border spinner-border-sm">
              <span class="sr-only">
                Loading...
              </span>
            </div>
          </button>
        </div>
      </div>
    </div>

    <modal-unsuccessful
      v-show="modal.unsuccessful"
      :text-modal="modal.textModal"
      @closeModal="closeModal"
    />
    <modal-success
      v-show="modal.success"
      :text-modal="modal.textModal"
      @closeModal="closeModal"
    />
  </portal>
</template>

<script>
import VSelect from 'vue-select'
import Draggable from 'vuedraggable'
import Api from '@/utils/Api'
import { required, numeric } from 'vuelidate/lib/validators'
import ModalUnsuccessful from '@/components/modal/ModalUnsuccessful'
import ModalSuccess from '@/components/modal/ModalSuccess'

export default {
  components: {
    VSelect,
    Draggable,
    ModalUnsuccessful,
    ModalSuccess
  },

  props: {
    id: {
      type: String,
      default: ''
    }
  },

  data: () => ({
    questionType: [
      { id: 'checkbox', name: 'Checkbox' },
      { id: 'radio_button', name: 'Radio Button' },
      { id: 'textbox', name: 'Textbox' }
    ],
    valueType: ['0', '1', '2'],
    form: {
      type: '',
      sequence: '',
      titleIdn: '',
      titleEng: '',
      isRequired: false
    },
    modal: {
      textModal: '',
      success: false,
      unsuccessful: false
    },
    initialStep: 0,
    choicesArr: [],
    isLoadingGet: false,
    isLoadingSubmit: false
  }),

  watch: {
    'form.type' () {
      if (this.initialStep !== 1) {
        this.choicesArr = []
      }
      this.initialStep = 0
    }
  },

  async created () {
    await this.initial()
  },

  methods: {
    getReduceId: ({ id }) => id,
    addChoices () {
      this.choicesArr.push({
        idAnswer: '',
        value: '',
        titleIdn: '',
        titleEng: '',
        id: this.choicesArr.length + 1
      })
    },
    deleteChoices (idDelete) {
      const index = this.choicesArr.findIndex(element => element.id === idDelete)
      this.choicesArr.splice(index, 1)
    },
    async initial () {
      this.isLoadingGet = true
      this.initialStep = 1
      const { data } = await Api.question.get(this.id)
      this.form = {
        type: data.type,
        sequence: data.sequence,
        titleIdn: data.titleIdn,
        titleEng: data.titleEng,
        isRequired: data.isRequired
      }
      for (let i = 1; i <= data.questionAnswers.length; i++) {
        const index = data.questionAnswers.findIndex(element => element.sequence === i)
        this.choicesArr.push({
          idAnswer: data.questionAnswers[index].id,
          id: i,
          titleIdn: data.questionAnswers[index].titleIdn,
          titleEng: data.questionAnswers[index].titleEng,
          value: data.questionAnswers[index].value.toString()
        })
      }
      this.isLoadingGet = false
    },
    showModal (modalname) {
      this.modal[modalname] = true
    },
    closeModal (modalname) {
      this.modal[modalname] = false
      if (modalname === 'success') {
        this.$emit('close', 'update')
      }
    },
    async submit () {
      this.$v.$touch()
      if (this.$v.$invalid) return

      this.isLoadingSubmit = true
      const formUpdate = this.form
      formUpdate.questionAnswers = []
      if (this.choicesArr.length) {
        formUpdate.questionAnswers = this.choicesArr.map(({ titleIdn, titleEng, value, idAnswer }, index) => ({
          titleIdn: titleIdn,
          titleEng: titleEng,
          value: value,
          sequence: index + 1,
          id: idAnswer,
          questionId: this.id
        }))
      }
      try {
        await Api.question.update(this.id, formUpdate)
        this.modal.textModal = this.$t('manage-question.success-update')
        this.showModal('success')
        this.isLoadingSubmit = false
      } catch ({ response }) {
        this.modal.textModal = response.statusText
        this.showModal('unsuccessful')
        this.isLoadingSubmit = false
      }
    }
  },

  validations: {
    form: {
      type: {
        required
      },
      sequence: {
        required,
        numeric
      },
      titleIdn: {
        required
      },
      titleEng: {
        required
      }
    },
    choicesArr: {
      $each: {
        value: {
          required
        },
        titleIdn: {
          required
        },
        titleEng: {
          required
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.card {
  max-width: 700px;
  margin: 0 auto;
}
.card-body {
  height: 450px;
}
textarea {
  resize: none;
}
.border-secondary {
  border-bottom: 2px solid #DEDEDE !important;
}
.drag-card {
  background-color: #F5F6FE;
}
</style>
